import { render, staticRenderFns } from "./ImageDisplay.vue?vue&type=template&id=7d5fa397&scoped=true&"
import script from "./ImageDisplay.vue?vue&type=script&lang=js&"
export * from "./ImageDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ImageDisplay.vue?vue&type=style&index=0&id=7d5fa397&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5fa397",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/jeffreymb/BibleLing/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d5fa397')) {
      api.createRecord('7d5fa397', component.options)
    } else {
      api.reload('7d5fa397', component.options)
    }
    module.hot.accept("./ImageDisplay.vue?vue&type=template&id=7d5fa397&scoped=true&", function () {
      api.rerender('7d5fa397', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ImageDisplay.vue"
export default component.exports